import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraAvatar, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraTooltip } from '@mono/ui-components/lieutenants';
/** Maps ONLYOFFICE `onRequestUsers` / users events to co-editors other than me. */ export function presenceFromEvent(event, selfId) {
    const raw = event?.data;
    if (!Array.isArray(raw)) return null;
    return raw.filter((u)=>!!u?.id && u.id !== selfId).map((u)=>({
            id: u.id,
            name: u.name
        }));
}
/**
 * Who else is in the document, for the `SpecraDocumentSurface` presence slot.
 * The Specra version of `pages/Editor/components/PresenceAvatars` (same
 * ONLYOFFICE users event, token colours instead of a hex palette).
 */ export function PresenceAvatars({ users, max = 4 }) {
    if (users.length === 0) {
        return /*#__PURE__*/ _jsx(SpecraText, {
            size: "meta",
            tone: "muted",
            children: "Only you"
        });
    }
    const shown = users.slice(0, max);
    const extra = users.length - shown.length;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-[var(--space-1-5)]",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex -space-x-[var(--space-1-5)]",
                children: shown.map((u)=>/*#__PURE__*/ _jsx(SpecraTooltip, {
                        content: u.name || 'Co-editor',
                        children: /*#__PURE__*/ _jsx(SpecraAvatar, {
                            className: "ring-2 ring-card",
                            name: u.name || '?',
                            size: "sm"
                        })
                    }, u.id))
            }),
            /*#__PURE__*/ _jsxs(SpecraText, {
                size: "meta",
                tone: "muted",
                children: [
                    extra > 0 ? `+${extra} · ` : '',
                    users.length,
                    " editing"
                ]
            })
        ]
    });
}
